var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoadingBox NoSelect"},[_c('div',{staticClass:"LoadingMain",style:({marginTop:_vm.boxTop+'px'})},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoadingIcon"},[_c('img',{attrs:{"src":"static/images/loading3.gif"}})])
}]

export { render, staticRenderFns }